import axios from 'axios';
import { API_URL, config } from '../../../config/config';

const decodeToken = (token) => {
	try {
		const parts = token.split('.');
		if (parts.length < 2) return null;
		return JSON.parse(atob(parts[1]));
	} catch {
		return null;
	}
};

// Service for Login admin
const signin = async (loginData) => {
	const response = await axios.post(`${API_URL}/auth/login`, loginData);
	if (response.data?.token) {
		localStorage.setItem('token', JSON.stringify(response.data.token));
	}
	return {
		...response.data,
		auth: decodeToken(response.data.token),
	};
};

// Service to get user
const getUser = async () => {
	const response = await axios.post(`${API_URL}/user-detail/getuser`, {}, config);
	return response.data;
};

const signOut = async () => {
	localStorage.clear();
};

const authService = {
	signin,
	getUser,
	signOut,
};

export default authService;
